import styled from "@emotion/styled";
import { MAX_DESKTOP_CONTENT_WIDTH, XS } from "constants/vp-sizes";
import DesktopHeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";
const HEADER_LOGO_HORIZONTAL_PADDING = `${DesktopHeaderConstants.HEADER_CONTENT_HORIZONTAL_PADDING}px`;
const MAX_DESKTOP_CONTENT_WIDTH_PX = `${MAX_DESKTOP_CONTENT_WIDTH}px`;
const XS_PX = `${XS}px`;
export const StyledHubspotSideBySideFormComponent = styled.div`
  margin: auto;

  &.align-to-logo {
    padding-left: ${HEADER_LOGO_HORIZONTAL_PADDING};
    padding-right: ${HEADER_LOGO_HORIZONTAL_PADDING};
  }

  @media (min-width: ${XS_PX}) and (max-width: ${MAX_DESKTOP_CONTENT_WIDTH_PX}) {
    .full-paragraph-component-wrapper {
      padding: 0 20px 20px 20px !important;
    }
  }

  @media (max-width: ${XS_PX}) {
    .side-by-side-content {
      padding: 0 64px;

      .full-paragraph-component-wrapper {
        padding: 0 20px 20px 20px !important;
      }
    }
  }
`;
